import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root'
})
export class CanvasService {

  constructor() { }

  async createCanvasFromHTML(element: HTMLElement): Promise<HTMLCanvasElement> {
    const canvas = await html2canvas(element, {scale: 3});
    return canvas;
  }
}
